import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** Renders a QR code for the given text (used for otpauth:// enrolment URIs). */
export function QrCode({ value, size = 196, label }: { value: string; size?: number; label: string }) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, { width: size, margin: 1, errorCorrectionLevel: 'M' })
      .then((url) => !cancelled && setSrc(url))
      .catch(() => !cancelled && setSrc(null));
    return () => {
      cancelled = true;
    };
  }, [value, size]);
  if (!src) return <div className="qr qr--empty" style={{ width: size, height: size }} aria-hidden="true" />;
  return <img className="qr" src={src} width={size} height={size} alt={label} />;
}
